import { Box, styled } from "@mui/material";

export const DocumentList = styled(Box)(() => ({
  marginTop: "20px",
})) as typeof Box;

export const DocumentListWrapper = styled(Box)(() => ({
  marginTop: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
})) as typeof Box;

export const DocumentListWrapperPagination = styled(Box)(() => ({
  width: "100%",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
})) as typeof Box;
